import React from "react";

const FdNcdArticle = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700&family=Source+Serif+4:ital,wght@0,300;0,400;0,600;1,300;1,400&family=Barlow:wght@400;500;600;700&display=swap');

        .fd-page * { box-sizing: border-box; }
        .fd-page {
          background: #f7f5f0;
          font-family: 'Source Serif 4', serif;
          color: #1a1a1a;
          min-height: 100vh;
        }

        /* HERO */
        .fd-hero {
          background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
          color: #fff;
          padding: 52px 24px 44px;
          border-bottom: 4px solid #c8a84b;
        }
        .fd-hero-inner { max-width: 1100px; margin: 0 auto; }
        .fd-hero-eyebrow {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 14px;
        }
        .fd-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(26px, 5vw, 48px);
          font-weight: 900;
          line-height: 1.1;
          color: #fff;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
        }
        .fd-hero-sub {
          font-family: 'Source Serif 4', serif;
          font-size: clamp(14px, 2vw, 17px);
          font-weight: 300;
          font-style: italic;
          color: rgba(255,255,255,0.72);
          max-width: 720px;
          line-height: 1.65;
        }
        .fd-hero-meta {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-top: 24px;
          padding-top: 20px;
          border-top: 1px solid rgba(255,255,255,0.12);
          flex-wrap: wrap;
        }
        .fd-hero-meta span {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          color: rgba(255,255,255,0.45);
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }
        .fd-sep { color: rgba(255,255,255,0.15) !important; }

        /* BODY */
        .fd-body { padding: 48px 24px 72px; }
        .fd-body-inner {
          max-width: 1100px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 40px;
          align-items: start;
        }

        /* SECTION */
        .fd-section { margin-bottom: 48px; }
        .fd-section-head {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #1a1a1a;
        }
        .fd-tag {
          font-family: 'Barlow', sans-serif;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 3px 10px;
          border-radius: 3px;
        }
        .fd-tag.gold  { background: #c8a84b; color: #1a1a1a; }
        .fd-tag.green { background: #1a5c38; }
        .fd-tag.blue  { background: #1a3a6b; }
        .fd-tag.teal  { background: #1a5c4a; }

        /* LEAD ARTICLE */
        .fd-lead h2 {
          font-family: 'Playfair Display', serif;
          font-size: clamp(20px, 3.5vw, 28px);
          font-weight: 800;
          color: #0f2027;
          line-height: 1.25;
          margin-bottom: 10px;
        }
        .fd-deck {
          font-size: 16px;
          font-weight: 300;
          font-style: italic;
          color: #555;
          line-height: 1.7;
          margin-bottom: 14px;
          border-left: 3px solid #c8a84b;
          padding-left: 14px;
        }
        .fd-body-text p {
          font-size: 15.5px;
          line-height: 1.85;
          color: #2a2a2a;
          margin-bottom: 14px;
          font-weight: 300;
        }

        /* HIGHLIGHT BOX */
        .fd-highlight {
          background: #0f2027;
          color: #fff;
          border-radius: 4px;
          padding: 22px 24px;
          margin: 20px 0;
        }
        .fd-highlight-label {
          font-family: 'Barlow', sans-serif;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.15em;
          text-transform: uppercase;
          color: #c8a84b;
          margin-bottom: 10px;
        }
        .fd-highlight p {
          font-family: 'Playfair Display', serif;
          font-size: 18px;
          font-style: italic;
          color: #fff;
          line-height: 1.65;
          margin: 0;
        }

        /* BULLETS */
        .fd-bullets { margin: 0; padding: 0; list-style: none; }
        .fd-bullets li {
          display: flex;
          gap: 12px;
          padding: 13px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 15px;
          line-height: 1.7;
          color: #2a2a2a;
          font-weight: 300;
        }
        .fd-bullets li:last-child { border-bottom: none; }
        .fd-dash {
          font-family: 'Barlow', sans-serif;
          font-weight: 700;
          color: #c8a84b;
          font-size: 18px;
          line-height: 1.5;
          flex-shrink: 0;
        }

        /* COMPARISON TABLE */
        .fd-table-wrap {
          border: 1.5px solid #1a1a1a;
          border-radius: 4px;
          overflow: hidden;
          margin: 20px 0;
        }
        .fd-table {
          width: 100%;
          border-collapse: collapse;
        }
        .fd-table thead {
          background: #0f2027;
          color: #fff;
        }
        .fd-table thead th {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          padding: 12px 16px;
          text-align: left;
        }
        .fd-table thead th:first-child { color: #c8a84b; }
        .fd-table tbody tr { border-bottom: 1px solid #e5e0d5; }
        .fd-table tbody tr:last-child { border-bottom: none; }
        .fd-table tbody tr:nth-child(even) { background: #faf8f4; }
        .fd-table td {
          padding: 12px 16px;
          font-size: 14.5px;
          line-height: 1.6;
          color: #2a2a2a;
          font-weight: 300;
        }
        .fd-table td:first-child {
          font-family: 'Barlow', sans-serif;
          font-weight: 600;
          font-size: 12px;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: #555;
          width: 160px;
        }
        .fd-table .highlight-val {
          font-family: 'Playfair Display', serif;
          font-size: 17px;
          font-weight: 700;
          color: #0f2027;
        }

        /* RETURN BOX */
        .fd-return-box {
          border: 2px solid #1a5c38;
          border-radius: 4px;
          overflow: hidden;
          margin: 20px 0;
        }
        .fd-return-head {
          background: #1a5c38;
          color: #fff;
          padding: 10px 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .fd-return-title {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .fd-return-badge {
          background: #c8a84b;
          color: #1a1a1a;
          font-family: 'Barlow', sans-serif;
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 3px 8px;
          border-radius: 2px;
        }
        .fd-return-body {
          background: #fff;
          padding: 16px 20px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
        }
        .fd-return-item { text-align: center; padding: 10px 0; }
        .fd-return-label {
          font-family: 'Barlow', sans-serif;
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: #888;
          margin-bottom: 6px;
        }
        .fd-return-val {
          font-family: 'Playfair Display', serif;
          font-size: 22px;
          font-weight: 700;
          color: #1a5c38;
        }

        /* SIDEBAR */
        .fd-sidebar { position: sticky; top: 24px; }
        .fd-widget { margin-bottom: 32px; }
        .fd-widget-head {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #fff;
          background: #0f2027;
          padding: 6px 12px;
          margin-bottom: 14px;
          display: inline-block;
        }

        /* Quick facts */
        .fd-facts { list-style: none; padding: 0; margin: 0; }
        .fd-facts li {
          padding: 10px 0;
          border-bottom: 1px solid #e5e0d5;
          font-size: 13.5px;
          line-height: 1.6;
          color: #333;
          font-weight: 300;
          display: flex;
          gap: 8px;
          align-items: flex-start;
        }
        .fd-facts li:last-child { border-bottom: none; }
        .fd-dot {
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #c8a84b;
          flex-shrink: 0;
          margin-top: 6px;
        }

        /* Stat widget */
        .fd-stat-box {
          background: #fff;
          border: 1px solid #e0dbd0;
          border-radius: 4px;
          overflow: hidden;
        }
        .fd-stat-item {
          padding: 14px 16px;
          border-bottom: 1px solid #e0dbd0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .fd-stat-item:last-child { border-bottom: none; }
        .fd-stat-label {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          color: #888;
        }
        .fd-stat-delta {
          font-family: 'Barlow', sans-serif;
          font-size: 11px;
          font-weight: 600;
          color: #1a5c38;
        }
        .fd-stat-val {
          font-family: 'Playfair Display', serif;
          font-size: 20px;
          font-weight: 700;
          color: #0f2027;
        }

        /* Disclaimer */
        .fd-disclaimer {
          background: #fff8e8;
          border-left: 3px solid #c8a84b;
          border-radius: 2px;
          padding: 14px 16px;
          font-size: 12.5px;
          color: #666;
          line-height: 1.7;
          font-style: italic;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .fd-body-inner { grid-template-columns: 1fr; }
          .fd-sidebar { position: static; }
          .fd-return-body { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 600px) {
          .fd-hero { padding: 36px 16px 32px; }
          .fd-body { padding: 32px 16px 56px; }
          .fd-return-body { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="fd-page">
        {/* ── HERO ── */}
        <div className="fd-hero">
          <div className="fd-hero-inner">
            <div className="fd-hero-eyebrow">
              💰 Financial Desk · May 22, 2026
            </div>
            <h1>
              Smart Investing: Why Fixed Deposits & NCDs Are Your Best
              Wealth-Building Tools
            </h1>
            <p className="fd-hero-sub">
              In a world full of complex financial instruments, two options
              continue to stand out for their simplicity, safety, and solid
              returns — FD and NCD.
            </p>
            <div className="fd-hero-meta">
              <span>🕐 4 min read</span>
              <span className="fd-sep">·</span>
              <span>📅 May 22, 2026</span>
              <span className="fd-sep">·</span>
              <span>✍️ Financial Desk Editorial</span>
            </div>
          </div>
        </div>

        {/* ── BODY ── */}
        <div className="fd-body">
          <div className="fd-body-inner">
            {/* ══ MAIN ══ */}
            <main>
              {/* Section 1 — Overview */}
              <div className="fd-section">
                <div className="fd-section-head">
                  <span className="fd-tag gold">📊 Investment Overview</span>
                </div>
                <div className="fd-lead">
                  <h2>
                    One Investment. Multiplied Returns. Two Powerful Paths.
                  </h2>
                  <p className="fd-deck">
                    Every person has a one-time savings amount that, when
                    invested wisely, can grow multiple times over. Here are the
                    two most reliable vehicles for this.
                  </p>
                </div>
                <div className="fd-body-text">
                  <p>
                    Whether you are a salaried professional, a business owner,
                    or a retiree looking for stable passive income, the
                    combination of Fixed Deposits and Non-Convertible Debentures
                    offers a powerful, regulated, and predictable path to wealth
                    creation — without the volatility of stock markets.
                  </p>
                  <p>
                    Financial experts increasingly recommend these two
                    instruments as the foundation of any sound investment
                    portfolio, particularly for investors who value capital
                    safety alongside meaningful returns.
                  </p>
                </div>
              </div>

              {/* Section 2 — Fixed Deposit */}
              <div className="fd-section">
                <div className="fd-section-head">
                  <span className="fd-tag blue">🏦 Fixed Deposit</span>
                </div>
                <div className="fd-lead">
                  <h2>Fixed Deposit — The Classic, Time-Tested Choice</h2>
                  <p className="fd-deck">
                    Bank FDs remain the most trusted investment product in India
                    — safe, predictable, and completely in your control.
                  </p>
                </div>
                <div className="fd-body-text">
                  <p>
                    A Fixed Deposit is the most straightforward investment you
                    can make. You deposit a lump sum with a bank, lock it in for
                    a chosen tenure, and earn a guaranteed interest rate —
                    regardless of market conditions.
                  </p>
                </div>

                <div className="fd-highlight">
                  <div className="fd-highlight-label">
                    📌 Real-World Example
                  </div>
                  <p>
                    A ₹5 lakh bank FD at 7% interest generates approximately
                    ₹35,000 every year — guaranteed. Your principal stays
                    intact, and your interest compounds or pays out annually,
                    year after year, without any active management.
                  </p>
                </div>

                <ul className="fd-bullets">
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      <strong>Principal Safety:</strong> Your initial ₹5 lakh is
                      fully protected and returned at maturity.
                    </span>
                  </li>
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      <strong>Annual Interest:</strong> ₹35,000 per year at 7%
                      rate — predictable and guaranteed.
                    </span>
                  </li>
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      <strong>Flexibility:</strong> Choose your tenure — 1 year
                      to 10 years — based on your financial goals.
                    </span>
                  </li>
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      <strong>Multiple FDs:</strong> You can open multiple FDs
                      to stagger maturity dates and maximize returns.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Section 3 — NCD */}
              <div className="fd-section">
                <div className="fd-section-head">
                  <span className="fd-tag green">
                    📈 NCD — Non-Convertible Debentures
                  </span>
                </div>
                <div className="fd-lead">
                  <h2>NCDs — The Monthly Income Powerhouse</h2>
                  <p className="fd-deck">
                    SEBI-regulated bonds that pay you every single month — while
                    growing your capital to remarkable totals over 6 years.
                  </p>
                </div>
                <div className="fd-body-text">
                  <p>
                    Non-Convertible Debentures are bonds issued by SEBI-approved
                    companies. Unlike Fixed Deposits with banks, NCDs are market
                    instruments — but they carry SEBI's regulatory backing,
                    making them a structured and trustworthy product for serious
                    investors.
                  </p>
                  <p>
                    The key advantage of NCDs is{" "}
                    <strong>monthly cash flow</strong>. Rather than waiting a
                    full year for interest, your money works for you every
                    single month.
                  </p>
                </div>

                {/* Return box */}
                <div className="fd-return-box">
                  <div className="fd-return-head">
                    <span className="fd-return-title">
                      NCD — ₹5 Lakh Investment Returns
                    </span>
                    <span className="fd-return-badge">6 Year Lock-in</span>
                  </div>
                  <div className="fd-return-body">
                    <div className="fd-return-item">
                      <div className="fd-return-label">Monthly Income</div>
                      <div className="fd-return-val">₹5,000</div>
                    </div>
                    <div className="fd-return-item">
                      <div className="fd-return-label">6-Year Interest</div>
                      <div className="fd-return-val">₹3.6L</div>
                    </div>
                    <div className="fd-return-item">
                      <div className="fd-return-label">Total Return</div>
                      <div className="fd-return-val">₹8.5L+</div>
                    </div>
                  </div>
                </div>

                <ul className="fd-bullets">
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      1 Year: ₹5,000 × 12 months ={" "}
                      <strong>₹60,000 annual interest</strong>
                    </span>
                  </li>
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      6 Years: Total interest collected ={" "}
                      <strong>₹3,60,000</strong>
                    </span>
                  </li>
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      Principal returned at maturity: <strong>₹5,00,000</strong>
                    </span>
                  </li>
                  <li>
                    <span className="fd-dash">—</span>
                    <span>
                      Grand total in hand: <strong>₹8,50,000+</strong> — a 9%+
                      cumulative return
                    </span>
                  </li>
                </ul>
              </div>

              {/* Section 4 — 2-in-1 */}
              <div className="fd-section">
                <div className="fd-section-head">
                  <span className="fd-tag teal">🏆 The 2-in-1 Benefit</span>
                </div>
                <div className="fd-lead">
                  <h2>Best of Both Worlds — Cumulative Returns Breakdown</h2>
                  <p className="fd-deck">
                    Investors who stay the full 6-year course walk away with
                    over ₹12 lakhs from an initial ₹5 lakh investment.
                  </p>
                </div>

                <div className="fd-table-wrap">
                  <table className="fd-table">
                    <thead>
                      <tr>
                        <th>Component</th>
                        <th>Amount</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Principal</td>
                        <td className="highlight-val">₹5,00,000</td>
                        <td>Returned fully at maturity</td>
                      </tr>
                      <tr>
                        <td>Annual Interest</td>
                        <td className="highlight-val">₹60,000</td>
                        <td>₹5,000/month × 12 months</td>
                      </tr>
                      <tr>
                        <td>6-Year Interest</td>
                        <td className="highlight-val">₹3,60,000</td>
                        <td>₹60,000 × 6 years</td>
                      </tr>
                      <tr>
                        <td>Cumulative Total</td>
                        <td
                          className="highlight-val"
                          style={{ color: "#1a5c38" }}
                        >
                          ₹12,00,000+
                        </td>
                        <td>Principal + all interest earned</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="fd-body-text">
                  <p>
                    That is a life-changing return that requires zero active
                    management. You invest once, collect monthly, and walk away
                    with more than double your original investment after six
                    years — all backed by SEBI regulation.
                  </p>
                </div>

                <div className="fd-disclaimer">
                  ⚠️ This article is for educational purposes only. Please
                  consult a SEBI-registered financial advisor before making any
                  investment decisions. Returns mentioned are illustrative and
                  subject to market and issuer conditions.
                </div>
              </div>
            </main>

            {/* ══ SIDEBAR ══ */}
            <aside className="fd-sidebar">
              {/* Quick facts */}
              <div className="fd-widget">
                <div className="fd-widget-head">At a Glance</div>
                <ul className="fd-facts">
                  {[
                    "FD: ₹5L at 7% = ₹35,000/year",
                    "NCD: ₹5L = ₹5,000/month",
                    "NCD lock-in period: 6 years",
                    "6-year NCD interest: ₹3,60,000",
                    "NCD cumulative return: 9%+",
                    "Total NCD payout: ₹12 lakh+",
                    "Both are SEBI/bank regulated",
                  ].map((fact) => (
                    <li key={fact}>
                      <span className="fd-dot" />
                      <span>{fact}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Stat widget */}
              <div className="fd-widget">
                <div className="fd-widget-head">Key Numbers</div>
                <div className="fd-stat-box">
                  {[
                    {
                      label: "FD Interest Rate",
                      val: "7%",
                      delta: "Per annum",
                    },
                    { label: "NCD Monthly", val: "₹5K", delta: "Per month" },
                    { label: "NCD Return", val: "9%+", delta: "Cumulative" },
                    { label: "Final Payout", val: "₹12L", delta: "In 6 years" },
                  ].map((s) => (
                    <div className="fd-stat-item" key={s.label}>
                      <div>
                        <div className="fd-stat-label">{s.label}</div>
                        <div className="fd-stat-delta">{s.delta}</div>
                      </div>
                      <div className="fd-stat-val">{s.val}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* FD vs NCD quick compare */}
              <div className="fd-widget">
                <div className="fd-widget-head">FD vs NCD</div>
                <div className="fd-stat-box">
                  {[
                    { label: "Issuer", fd: "Bank", ncd: "Company" },
                    { label: "Payout", fd: "Yearly", ncd: "Monthly" },
                    { label: "Lock-in", fd: "Flexible", ncd: "6 Years" },
                    { label: "Regulator", fd: "RBI", ncd: "SEBI" },
                  ].map((row) => (
                    <div className="fd-stat-item" key={row.label}>
                      <div className="fd-stat-label">{row.label}</div>
                      <div style={{ textAlign: "right" }}>
                        <div
                          style={{
                            fontSize: "12px",
                            fontFamily: "Barlow, sans-serif",
                            fontWeight: 600,
                            color: "#1a3a6b",
                          }}
                        >
                          FD: {row.fd}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontFamily: "Barlow, sans-serif",
                            fontWeight: 600,
                            color: "#1a5c38",
                          }}
                        >
                          NCD: {row.ncd}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
};

export default FdNcdArticle;
